module.exports = __webpack_public_path__ + "img/pliante.4af4a25.svg";